// extracted by mini-css-extract-plugin
export default {"alert":"Alert_alert__njX-k","green":"Alert_green__G17OW","red":"Alert_red__DMaNm","purple":"Alert_purple__yxjNd","alertCross":"Alert_alertCross__BUQ2R"};